import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLogoTwitch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 104 48'
    {...props}
  >
    <g clipPath='url(#Logo_Twitch_svg__a)'>
      <path
        fill='#6441A5'
        fillRule='evenodd'
        d='m100.859 18.724-4.103-4.103h-7.622V9.344h-6.45V33.38h6.45V21.068h5.275V33.38h6.45zM80.341 14.62h-9.966l-4.104 4.103v10.551l4.104 4.105h9.966v-6.448h-7.622v-5.864h7.622zm-16.415 0h-5.275V9.344h-6.45v19.931l4.104 4.105h7.621v-6.448h-5.275v-5.864h5.275zm-14.07-5.277H43.41v2.932h6.448zm0 5.277H43.41v18.758h6.448zm-8.792 0h-6.449v12.31h-2.344v-12.31h-6.448v12.31h-2.344v-12.31h-6.45V33.38H36.96l4.103-4.105zm-26.38 0H9.409V9.344H2.96v19.931l4.104 4.105h7.62v-6.448H9.409v-5.864h5.275zm88.518 2.93v17.586L94.409 41h-5.862v-2.932L84.444 41h-5.275v-2.932L76.239 41h-9.38l-2.933-2.932L63.34 41h-8.205l-3.356-2.932L51.59 41h-9.301l-.33-2.932L39.443 41H25.236l-2.932-1.173V41h-7.62L5.89 35.723.615 30.449V7h11.139l5.275 5.276h24.035V7h19.931v5.276h5.276v2.93l2.932-2.93h5.861L80.341 7h11.138v5.276h6.448z'
        clipRule='evenodd'
      />
    </g>
    <defs>
      <clipPath id='Logo_Twitch_svg__a'>
        <path fill='#fff' d='M.615 0h103v48h-103z' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoTwitch;
